import { Injectable } from '@angular/core';
import { Table_Configuration } from './table';

@Injectable()
export class TableService {
    constructor() {}

    // Below function is used to set the chip color and the text in the chip in the listing
    set_Chip_Color_Name_Listing(header_name: string, contentValue: boolean | string) {
        let status = '';
        let chipColorClass = '';

        switch (header_name) {
            case 'Enable/Disable':
                return this.mapBooleanToStatus(contentValue, 'Enabled', 'Disabled');
            case 'Status':
                return this.mapBooleanToStatus(contentValue, 'Active', 'Inactive');
            case 'status':
                if (typeof contentValue === 'string') {
                    status = contentValue;

                    switch (contentValue.toLowerCase()) {
                        case 'success':
                            chipColorClass = 'success-bg-color-opacity';
                            break;
                        case 'pending':
                            chipColorClass = 'pending-bg-color-opacity';
                            break;
                        case 'failed':
                            chipColorClass = 'error-bg-color-opacity';
                            break;
                    }
                }
                break;
            case 'ZLD':
                status = contentValue ? 'Yes' : 'No';
                chipColorClass = contentValue ? 'success-bg-color-opacity' : 'error-bg-color-opacity';
                break;
        }
        return { status, chipColorClass };
    }

    private mapBooleanToStatus(contentValue: boolean | string, trueStatus: string, falseStatus: string) {
        const status = contentValue ? trueStatus : falseStatus;
        const chipColorClass = contentValue ? 'success-bg-color-opacity' : 'error-bg-color-opacity';
        return { status, chipColorClass };
    }

    createHeaderList(tableConfiguration: Table_Configuration[]) {
        return tableConfiguration.map((col: Table_Configuration) => col.header_name);
    }
}
